import { useIsEmeaCountry } from '../useIsEmeaCountry';

/**
 * `isSettlementAgentEnabled` is provisional until `loading` clears — except with no country code,
 * where there is nothing to resolve.
 */
export function useIsSettlementAgentEnabledOnOffering(
  countryCode: string | null | undefined
): Readonly<{ isSettlementAgentEnabled: boolean; loading: boolean }> {
  const { isEmea, loading } = useIsEmeaCountry(countryCode ?? '');

  if (!countryCode) {
    return { isSettlementAgentEnabled: true, loading: false };
  }

  return { isSettlementAgentEnabled: !isEmea, loading };
}
